import { Trans } from '@lingui/react/macro';
import { createFileRoute, Link } from '@tanstack/react-router';
import { CenteredShell, PageEyebrow, ProTip } from '../components/auth-shells.js';
import { Mag } from '../components/mag.js';

export const Route = createFileRoute('/reset-password/success')({
  component: ResetSuccessPage,
});

// Handoff §15.2.7 — centered shell. Big "password set." with serif italic
// quote underneath, the back-to-home primary, and a yellow pro-tip callout
// nudging the user toward magic links next time.
function ResetSuccessPage() {
  return (
    <CenteredShell>
      <Mag size={86} />
      <PageEyebrow>
        <Trans>done</Trans>
      </PageEyebrow>
      <h1 className="font-display text-[80px] font-black leading-[1] tracking-[-0.045em]">
        <Trans>password set.</Trans>
      </h1>
      <p className="font-serif text-2xl leading-tight text-[var(--ink)]/85">
        <Trans>“back to it. i'll keep things moving.”</Trans>
      </p>
      <div className="mt-2">
        <Link to="/home" className="btn">
          <Trans>back to home</Trans>
          <span className="btn-arrow">→</span>
        </Link>
      </div>
      <div className="mt-6 w-full max-w-[440px]">
        <ProTip>
          <Trans>
            <span className="font-semibold">pro tip:</span> next time, skip the password — use a
            magic link. one less thing to lose.
          </Trans>
        </ProTip>
      </div>
    </CenteredShell>
  );
}
